module.exports = __webpack_public_path__ + "static/img/icon_question.002b76b8.svg";